/**
 * Static, blog-content-independent metadata for the "Ratgeber" mega-menu:
 * types, color theme, active-path matching, and the tracker article's path.
 * Safe to import directly from client components ("use client" Navbar/
 * MegaMenu/MobileMegaMenu) — unlike `lib/ratgeber-columns.ts`, nothing here
 * touches `lib/blog.ts`'s full article dataset.
 */

export type RatgeberIcon = "zulassung" | "zulassungsrechner" | "bewerbung";
export type RatgeberColor = "emerald" | "blue" | "amber";

export type RatgeberLink = { label: string; href: string };

export type RatgeberColumn = {
  id: string;
  icon: RatgeberIcon;
  color: RatgeberColor;
  title: string;
  description: string;
  links: RatgeberLink[];
  footer: RatgeberLink;
};

/** Farbthema je Spalte (Icon-Kachel, Link-Hover, Footer-Link). */
export const ratgeberTheme: Record<
  RatgeberColor,
  { tile: string; linkHover: string; footer: string }
> = {
  emerald: {
    tile: "bg-emerald-100 text-emerald-700",
    linkHover: "hover:text-emerald-700",
    footer: "text-emerald-600 hover:text-emerald-700",
  },
  blue: {
    tile: "bg-blue-100 text-blue-700",
    linkHover: "hover:text-blue-700",
    footer: "text-blue-600 hover:text-blue-700",
  },
  amber: {
    tile: "bg-amber-100 text-amber-600",
    linkHover: "hover:text-orange-600",
    footer: "text-orange-500 hover:text-orange-600",
  },
};

/** Ratgeber-Übersicht (app/ratgeber/page.tsx) – Ziel des „Alle Ratgeber"-Links im Menü. */
export const RATGEBER_PATH = "/ratgeber/";

/** Pfade, bei denen der „Ratgeber"-Menüpunkt als aktiv markiert wird. */
export const ratgeberActivePaths = ["/ratgeber"];

/**
 * Der Aufrück-Tracker-Artikel hat in der Navbar einen eigenen, dominanten
 * Menüpunkt. Auf dieser einen Seite soll deshalb nicht zusätzlich „Ratgeber"
 * aktiv markiert werden – überall sonst unter /ratgeber/ bleibt es dabei.
 */
export const TRACKER_ARTICLE_PATH =
  "/ratgeber/zulassungsrechner/aufruecken-im-vergabeverfahren/";
